import * as Yup from "yup";

export const TaskCreationSchema = Yup.object().shape({
  assigned_to_name: Yup.array()
    .of(Yup.string())
    .min(1, "Please select at least one employee")
    .max(3, "You can select maximum 3 employees")
    .required("Please select employee"),

  task_description: Yup.string()
    .required("Please enter description")
    .trim()
    .max(150, "Task description should not exceed 150 characters")
    .matches(/[^\d\W_]/, "Description cannot contain only numbers or special characters"),

  due_date: Yup.string().required("Please select due date"),

 
  due_time: Yup.string()
    .required("Please select due time")
    .test("is-future-time", "Time cannot be in the past", function (value) {
      const { due_date } = this.parent;
      if (!due_date || !value) return true; 

      const currentDate = new Date();
      const selectedDateTime = new Date(`${due_date}T${value}`);

   
      if (new Date(due_date).toDateString() === currentDate.toDateString()) {
         return selectedDateTime > currentDate;
      }
      return true;
    }),

  priority: Yup.string()
    .required("Please select priority")
    .oneOf(['High', 'Medium', 'Low'], "Invalid priority selected"),
});